'use strict';

angular.module('shiftTraderApp')
    .controller('DaysOffContentPendingCtrl', function($scope, AvailabilityRules, TimeService, $state, $stateParams, $location,
                                           SAErrorHandler, $timeout, me, daysOff, org, $rootScope, DaysOffStore,
                                           Session, allMinUsers, $interval, DaysOffUserStatsService, WorkPeriods,
                                           DaysOffRouteSyncService, $uibModal, DaysOffManagementModalService) {
      $scope.me = me;
      $scope.org = org;

      var baseDaysOff = daysOff;

      $scope.allDepartments = _.map($scope.org.departments, function(dept) {
        dept._selected = true;
        return dept;
      });

      $scope.allMinUsers = _.sortBy(_.map(_.where(allMinUsers, function(u) {
        return u.$curMemb().active === 1;
      }), function(u) {
        u._filteredDayOffCount = 0;
        return u;
      }), 'first_name');

      $scope.nowDate = TimeService.getNowInStoreTime();
      $scope.currentDate = TimeService.getBeginningOfDayFromDate(moment.utc($stateParams.date)).startOf('month');
      $scope.workDayStartHour = Session.getWorkDayStartHour();

      $scope.state = {
        selectedDepartments: _.cloneDeep($scope.org.departments),
        selectedStatuses: {
          approved: true,
          pending: true,
          disapproved: true
        }
      };

      var firstWeek = TimeService.getWeekTwixFromMoment($scope.currentDate);

      $scope.weeks = _.map([0,1,2,3,4,5], function(x) {
        return (moment(firstWeek.start).add(x, 'weeks')).twix(moment(firstWeek.start).add(x+1, 'weeks'));
      });

      //clip it down to the last week that has a day in the current month
      _.each([5,4], function(x) {
        if (!$scope.weeks[1].start.isSame($scope.weeks[x].start, 'month')) {
          $scope.weeks.splice(x,1);
        }
      });
      var currentViewDateRange = $scope.weeks[0].start.twix($scope.weeks[$scope.weeks.length-1].end);

      var setDayOffProperties = function(dayOff) {
        dayOff._cssClasses = {};
        if (dayOff.$isApproved()) {
          dayOff._cssClasses.approved = true;
        } else if (dayOff.$isDisapproved()) {
          dayOff._cssClasses.disapproved = true;
        } else if (dayOff.$isPending() && !dayOff.$isExpired()) {
          dayOff._cssClasses.pending = true;
        } else if (dayOff.$isPending() && dayOff.$isExpired()) {
          dayOff._cssClasses.expired = true;
        }
        return dayOff;
      };

    $rootScope.$on('daysOff:filterChange', function() {
      var filters = DaysOffRouteSyncService.getFilters();

      $scope.state.selectedDepartments = _.where($scope.allDepartments, function(dept) {
        return _.contains(filters.departmentIds, dept.id);
      });

      calculateDaysOffDataStructure();
    });

      $scope.datesByWeek = _.map($scope.weeks, function(week) {
        return _.map(_.range(7), function(dayNum) {
          return moment(week.start).add(dayNum, 'days').twix(moment(week.start).add(dayNum + 1, 'days'));
        });
      });

      var calculateDaysOffDataStructure = function () {
        var departmentIdsToShow = _.pluck($scope.state.selectedDepartments, 'id');
        $scope.filteredDaysOff = _.where($scope.allDaysOff, function(dor) {
          var hasDeptMetadata = dor.user.metadata && dor.user.metadata.department_ids_by_org &&
              dor.user.metadata.department_ids_by_org.data && dor.user.metadata.department_ids_by_org.data[dor.organization_id]
            && dor.user.metadata.department_ids_by_org.data[dor.organization_id].length > 0;

          return !hasDeptMetadata || _.any(departmentIdsToShow, function(idToShow) {
            return _.contains(dor.user.metadata.department_ids_by_org.data[dor.organization_id], idToShow);
          });
        });

        function setDayOffClasses(dayOff, dt) {
          var clone = _.cloneDeep(dayOff);
          clone._cssClasses = {
            continues: dayOff.range_twix.end.isAfter(dt.end),
            from_last: dayOff.range_twix.start.isBefore(dt.start)
          };
          return clone;
        }

        var workDayStartHour = Session.getWorkDayStartHour();
        $scope.daysOffByWeek = _.map($scope.datesByWeek, function (weekOfDays, idx) {

          return {
            week: $scope.weeks[idx],
            days: _.map(weekOfDays, function (dayTwix) {
              var overlappingDaysOff = _.where($scope.filteredDaysOff, function(dayOff) {

                var isMultiDayRequest = dayOff.range_twix.start.dayOfYear() !== dayOff.range_twix.end.dayOfYear();
                var dtIntersection = dayTwix.overlaps(dayOff.range_twix) ? Math.abs(dayOff.range_twix.intersection(dayTwix).length('minutes')) : 0;

                // if this is a single day request OR if the request overlaps the day by MORE than dayStartHour hrs, then show it.
                return !dayOff.$wasCancelledOrRemoved() && ((!isMultiDayRequest && dtIntersection > 0) || (isMultiDayRequest && dtIntersection > ( workDayStartHour * 60)));


                //return dayOff.range_twix.overlaps(dayTwix) &&
                //  Math.abs(dayOff.range_twix.intersection(dayTwix).length('minutes')) > 0 &&
                //  dayOff.range_twix.end.isAfter(moment(dayTwix.start).add($scope.workDayStartHour, 'hours'), 'minute');
              });

              var temp = {
                range_twix: dayTwix,
                _cssClasses: {
                  previous_month: dayTwix.start.isBefore($scope.currentDate),
                  next_month: dayTwix.start.isAfter(moment($scope.currentDate).endOf('month'))
                },
                items: overlappingDaysOff.map(function(x) { return setDayOffClasses(x, dayTwix)})
              };

              return temp;
            })
          };
        });
      };


      $scope.focusOnDay = function(range_twix) {
        $scope.openDayOffManagementModal(range_twix.start);
      };

      $scope.openDayOffManagementModal = function(dt) {
        console.log('dt in openDayOffManagementModal', dt.format());
        DaysOffManagementModalService.setCurrentDate(dt);

        var modalInstance = $uibModal.open({
          size: 'days-off-management',
          templateUrl: 'views/daysOff/daysOffManagementModal.html',
          controller: 'DaysOffManagementModalCtrl',
          resolve: {
            params: function() {
              return {
                me: $scope.me,
                org: $scope.org,
                allUsers: $scope.allMinUsers
              };
            }
          },
          rxName: 'days-off-management'
        });
        modalInstance.result.then(function(result) {
            console.log('closed days off management modal');
            console.log(result);
            reloadDaysOffData();
          },
          function(reason) {
            console.log('dismissed explanation with reason ' + reason);

          });
      };

    function processBaseDaysOff() {
      $scope.allDaysOff = _.map(_.where(baseDaysOff, function(dayOff) {
        return currentViewDateRange.overlaps(dayOff.range_twix) &&
          Math.abs(currentViewDateRange.intersection(dayOff.range_twix).length('minutes')) > 0;
      }), function(dayOff) {
        return setDayOffProperties(dayOff);
      });

      calculateDaysOffDataStructure();
    }

    function reloadDaysOffData() {
      var startDate = moment($scope.currentDate).startOf('month').subtract(1, 'week');
      var endDate = moment($scope.currentDate).endOf('month').add(1, 'week');

       DaysOffStore.getDaysOffBetween(startDate, endDate, true)
         .then(function(results) {
           baseDaysOff = results;
           processBaseDaysOff();
         }, function(response) {

         });
    }

    processBaseDaysOff();

    });
